module.exports = __webpack_public_path__ + "static/media/006-linkedin-black.75187040.svg";